export default class ActionDto {
    constructor() {
        this.id = 0;
        this.condition = null;
        this.type = '';
        this.valueSettings = {};
        this.position = 1;
        this._valueRule = null;
    }
}
//# sourceMappingURL=action-dto.js.map